// extracted by mini-css-extract-plugin
export default {"tabs":"FoodTabs_tabs__-wn+8","tabButton":"FoodTabs_tabButton__7aVez","active":"FoodTabs_active__gmPHy"};